module.exports = __webpack_public_path__ + "img/image1.5192bf37.webp";